import { Button, ButtonProps, alpha, useTheme, CircularProgress, Box } from '@mui/material';
import { ReactNode } from 'react';

interface SocialAuthButtonProps extends Omit<ButtonProps, 'variant' | 'fullWidth'> {
  icon: ReactNode;
  label: string;
  loading?: boolean;
}

const SocialAuthButton = ({
  icon,
  label,
  loading = false,
  disabled = true,
  sx,
  ...props
}: SocialAuthButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      fullWidth
      variant="outlined"
      disabled={disabled || loading}
      startIcon={
        loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CircularProgress size={16} color="inherit" />
            {icon}
          </Box>
        ) : (
          icon
        )
      }
      sx={{
        py: 1.2,
        borderRadius: 1.5,
        textTransform: 'none',
        fontSize: '0.9rem',
        borderColor: 'divider',
        color: 'text.primary',
        position: 'relative',
        '&:hover': {
          borderColor: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:disabled': {
          borderColor: 'divider',
          color: 'text.secondary',
          backgroundColor: alpha(theme.palette.action.disabled, 0.05),
        },
        ...sx,
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default SocialAuthButton;
